import { ClipboardType, clipboardWrite } from "js/core/utilities/clipboard";

export function fallbackCopyText(text) {
    if (!document?.body || !document.execCommand) {
        return false;
    }

    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "fixed";
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.opacity = "0";
    textArea.style.pointerEvents = "none";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange(0, text.length);

    let copied = false;
    try {
        copied = document.execCommand("copy");
    } catch {
        copied = false;
    }

    document.body.removeChild(textArea);
    return copied;
}
export async function copyShareLink(url, {
    clipboardWriteImpl = clipboardWrite,
    fallbackCopyImpl = fallbackCopyText,
} = {}) {
    try {
        const copied = await clipboardWriteImpl({ [ClipboardType.TEXT]: url });
        if (copied) {
            return "copied";
        }
    } catch {
        if (fallbackCopyImpl(url)) {
            return "copied";
        }
        return "manual";
    }

    if (fallbackCopyImpl(url)) {
        return "copied";
    }

    return "manual";
}
